import styles from "./m3.module.css";

/**
 * Compact row of label / value pairs, e.g. the inputs a calculation used.
 *
 * @param {Array} items - { label, value, hidden? }
 * @param {"grid"|"inline"} variant - "grid": boxed even columns; "inline": one quiet line with dividers
 */
export const SpecList = ({ items = [], variant = "grid" }) => (
  <dl className={variant === "inline" ? styles.specInline : styles.specList}>
    {items
      .filter((item) => item && !item.hidden)
      .map((item) => (
        <div key={item.label} className={styles.specItem}>
          <dt className={styles.specLabel}>{item.label}</dt>
          <dd className={styles.specValue}>{item.value ?? "—"}</dd>
        </div>
      ))}
  </dl>
);

/**
 * Even grid for KpiTile children. `columns` is the count on wide screens (default 4);
 * it drops to 2 on tablets and 1 on phones. `dense` uses a tighter gap for compact tiles.
 */
export const KpiGrid = ({ children, columns = 4, dense = false }) => (
  <div className={`${styles.kpiGrid} ${dense ? styles.kpiGridDense : ""}`} style={{ "--kpi-cols": columns }}>
    {children}
  </div>
);

export default SpecList;
